{
  "api": {
    "locationValidationTitle": "تعذر التحقق من موقعك",
    "thresholdTitle": "لست في الوقت المناسب لتسجيل الوصول",
    "warehouseUnavailableTitle": "المستودع غير متاح",
    "warehouseUnavailableMessage": "يرجى التواصل مع موظفي المنشأة لإتمام تسجيل الوصول يدويًا",
    "characterLimitTitle": "المدخل يتجاوز حد الأحرف",
    "genericTitle": "فشل تسجيل الوصول. يرجى المحاولة مرة أخرى.",
    "recaptchaTitle": "فشل التحقق",
    "recaptchaMessage": "تعذّر التحقق من طلبك. يرجى المحاولة مرة أخرى أو التواصل مع موظفي المنشأة."
  }
}
